import { render, staticRenderFns } from "./Username.vue?vue&type=template&id=48b343f5&scoped=true&"
import script from "./Username.vue?vue&type=script&lang=js&"
export * from "./Username.vue?vue&type=script&lang=js&"
import style0 from "./Username.vue?vue&type=style&index=0&id=48b343f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b343f5",
  null
  
)

export default component.exports